import { __assign, __read, __spread } from "tslib";
/* eslint-disable react/destructuring-assignment */
import React from "react";
import { useDefaultValue } from "../form/controlled";
import { noop } from "../_util/noop";
import { flatten } from "../_util/flatten";
import { SliderTrack } from "./SliderTrack";
export var Slider = React.forwardRef(function Slider(props, ref) {
    var _a = props.min, min = _a === void 0 ? 0 : _a, max = props.max, range = props.range;
    var rebuildValidRange = function (range) {
        var validRange = Array.isArray(range) ? range : [min, max];
        if (typeof validRange[0] !== "number" || validRange[0] < min) {
            validRange[0] = min;
        }
        if (typeof validRange[1] !== "number" || validRange[1] > max) {
            validRange[1] = max;
        }
        return validRange;
    };
    var validRange;
    if (props.rangeMode === true) {
        validRange = rebuildValidRange(range);
        return React.createElement(RangeSlider, __assign({ ref: ref }, props, { range: validRange }));
    }
    // 单值类型支持多区间
    validRange = Array.isArray(range) && range.length > 0 ? range : [];
    if (Array.isArray(range) &&
        (typeof range[0] === "number" || typeof range[1] === "number")) {
        validRange = [range];
    }
    validRange = validRange
        .filter(function (item) { return Array.isArray(item); })
        .map(function (item) { return rebuildValidRange(item); });
    return React.createElement(SingleSlider, __assign({ ref: ref }, props, { range: validRange }));
});
Slider.displayName = "Slider";
var SingleSlider = React.forwardRef(function SingleSlider(props, ref) {
    var range = props.range, _a = props.dotValues, dotValues = _a === void 0 ? [] : _a, _b = props.min, min = _b === void 0 ? 0 : _b, max = props.max;
    var defaultValues = flatten(__spread(dotValues, range)).sort(function (a, b) {
        return a > b ? 1 : -1;
    });
    var defaultDefaultValue = defaultValues.length > 0 ? defaultValues[0] : 0;
    defaultDefaultValue = defaultDefaultValue < min ? min : defaultDefaultValue;
    defaultDefaultValue = defaultDefaultValue > max ? max : defaultDefaultValue;
    var _c = useDefaultValue(props, defaultDefaultValue), value = _c.value, onChange = _c.onChange, _d = _c.onUpdate, onUpdate = _d === void 0 ? noop : _d;
    return (React.createElement(SliderTrack, __assign({ ref: ref }, props, { value: [props.min || 0, value], onUpdate: function (value) {
            onUpdate(value[1]);
        }, onChange: function (value, context) {
            onChange(value[1], context);
        } })));
});
SingleSlider.displayName = "SingleSlider";
var RangeSlider = React.forwardRef(function RangeSlider(props, ref) {
    var defaultDefaultValue = props.range[0] || 0;
    var _a = useDefaultValue(props, [
        defaultDefaultValue,
        defaultDefaultValue,
    ]), value = _a.value, onChange = _a.onChange;
    return (React.createElement(SliderTrack, __assign({ ref: ref }, props, { value: value, onChange: function (value, context) {
            onChange(value, context);
        } })));
});
RangeSlider.displayName = "RangeSlider";
//# sourceMappingURL=Slider.js.map